module.exports = __webpack_public_path__ + "static/media/wmsui32_2220.5446c689.ico";